import type { TypeSelectOption } from '@thefarmersfront/kitchen';

import { transformToSelectOptions } from '~/utils';

import type { TypeProductCodeName } from '~/types/product.types';

/**
 * @description
 * 상품관리 > select 에서 사용하는 오더유형에 해당하는 ENUM 값 code-name 페어를 kitchen의 select option에 맞게 형변환을 하는 함수
 * @returns TypeSelectOption[] 예시: `code (name)`
 *
 */

const transformToProductDeliveryTypeOptions = (arr: TypeProductCodeName[]): TypeSelectOption<string>[] => {
  return transformToSelectOptions(arr, 'code', 'name', (value, text) => `${text} (${value})`);
};

export default transformToProductDeliveryTypeOptions;
